import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var YoukoWithCircle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 .4C4.698.4.4 4.698.4 10s4.298 9.6 9.6 9.6 9.6-4.298 9.6-9.6S15.302.4 10 .4zm-.404 9.08C9 10.83 8.51 11.96 7.933 13.265c-.283.639-.503 1.345-1.021 1.684-2.144.135-.544-2.254-.227-3.099-.487-.93-1.126-2.011-1.701-3.022-.263-.46-.917-1.34-.265-1.836.241-.184.777-.189 1.02 0 .758.586 1.187 2.186 1.815 2.907.233-.4.442-.948.681-1.492.217-.494.396-1.19.718-1.415.494-.345 1.26-.045 1.361.459.127.636-.47 1.466-.718 2.027zm4.99 3.289c-.396-.086-.757-.647-1.133-.995-.393-.361-.827-.689-1.135-.994-.21-.32-.151.217-.151.535v.919c-.041.328-.218.519-.53.573h-.453c-.328-.038-.464-.27-.53-.573V7.988c.006-.812 1.507-.812 1.513 0v1.491c.242-.124.388-.346.567-.535a2.59 2.59 0 00.416-.421c.255-.227.494-.469.718-.727.299-.626 1.462-.583 1.55.192.122 1.072-1.322 1.45-1.588 2.065.395.537 1.309.925 1.626 1.53.3.573-.058 1.362-.87 1.186z"
  }));
});
YoukoWithCircle.displayName = 'YoukoWithCircle';
export var YoukoWithCircleDimensions = {
  height: 20,
  width: 20
};